import { render, staticRenderFns } from "./PrinterTypeModal.vue?vue&type=template&id=16001054&scoped=true&"
import script from "./PrinterTypeModal.vue?vue&type=script&lang=js&"
export * from "./PrinterTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16001054",
  null
  
)

export default component.exports